var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("q-table", {
        staticClass: "q-mt-md",
        attrs: {
          data: _vm.history,
          columns: _vm.columns_history,
          pagination: _vm.server_pagination,
          loading: _vm.loading,
          "row-key": "id",
          "no-data-label": _vm.$t("no_data_avaliable"),
          "no-results-label": _vm.$t("no_results_found"),
          "loading-label": _vm.$t("loading_data"),
          "rows-per-page-label": _vm.$t("items_per_page"),
          "rows-per-page-options": [0],
          "binary-state-sort": ""
        },
        on: {
          "update:pagination": function($event) {
            _vm.server_pagination = $event
          },
          request: _vm.requestHistory
        },
        scopedSlots: _vm._u([
          {
            key: "header",
            fn: function(props) {
              return _c(
                "q-tr",
                { attrs: { props: props } },
                _vm._l(props.cols, function(col) {
                  return _c(
                    "q-th",
                    { key: col.name, attrs: { props: props } },
                    [
                      _vm._v(
                        "\n                " +
                          _vm._s(_vm.$t(col.label)) +
                          "\n            "
                      )
                    ]
                  )
                }),
                1
              )
            }
          },
          {
            key: "body",
            fn: function(props) {
              return _c(
                "q-tr",
                {},
                [
                  _c(
                    "q-td",
                    { key: "author_full_name", attrs: { props: props } },
                    [
                      _vm._v(
                        "\n                " +
                          _vm._s(props.row.author_full_name) +
                          "\n            "
                      )
                    ]
                  ),
                  _c("q-td", { key: "author_email", attrs: { props: props } }, [
                    _vm._v(
                      "\n                " +
                        _vm._s(props.row.author_email) +
                        "\n            "
                    )
                  ]),
                  _c(
                    "q-td",
                    {
                      key: "observation_type_slug",
                      attrs: { "auto-width": "", props: props }
                    },
                    [
                      _c(
                        "q-chip",
                        {
                          staticClass: "full-width",
                          attrs: {
                            small: "",
                            icon: _vm.getTypeIcon(
                              props.row.observation_type_slug
                            ),
                            color: _vm.getTypeColor(
                              props.row.observation_type_slug
                            )
                          }
                        },
                        [
                          _vm._v(
                            "\n                    " +
                              _vm._s(_vm.$t(props.row.observation_type_slug)) +
                              "\n                "
                          )
                        ]
                      )
                    ],
                    1
                  ),
                  _c("q-td", { key: "created_date", attrs: { props: props } }, [
                    _vm._v(
                      "\n                " +
                        _vm._s(_vm.fDate(props.row.created_date)) +
                        "\n            "
                    )
                  ]),
                  _c(
                    "q-td",
                    {
                      key: "observation",
                      staticStyle: {
                        display: "flex",
                        "align-items": "center",
                        height: "auto",
                        "white-space": "break-spaces",
                        "min-height": "50px"
                      },
                      attrs: { props: props }
                    },
                    [
                      _vm._v(
                        "\n                " +
                          _vm._s(props.row.observation) +
                          "\n            "
                      )
                    ]
                  )
                ],
                1
              )
            }
          }
        ])
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }